/**
 * Serialized, debounced writes. flush() waits for the latest draft, including
 * edits made during an older save. A failed write remains dirty and is retryable.
 * No React, timers or network are required by the tests: all are injectable.
 */
export function createDraftSaver({ save, onStatus = () => {}, delay = 900, schedule = setTimeout, clear = clearTimeout }) {
 let latest = null; let saved = null; let timer = null; let pending = null; let active = true; let error = null;
 const report = () => { if (active) onStatus({ dirty: latest !== saved, saving: Boolean(pending), error }); };
 const cancelTimer = () => { if (timer !== null) clear(timer); timer = null; };
 const flush = () => {
  cancelTimer();
  if (!active) return Promise.reject(new Error('The editor is closed.'));
  if (pending) return pending;
  if (latest === null || latest === saved) return Promise.resolve();
  error = null;
  pending = Promise.resolve().then(async () => {
   while (active && latest !== saved) {
    const body = latest;
    await save(JSON.parse(body));
    saved = body;
   }
  }).catch((err) => { error = err; throw err; }).finally(() => { pending = null; report(); });
  report();
  return pending;
 };
 return {
  seed(value) { if (latest === null) { latest = JSON.stringify(value); saved = latest; report(); } },
  change(value) {
   if (!active) return;
   latest = JSON.stringify(value); error = null; cancelTimer(); report();
   if (latest !== saved) timer = schedule(() => { timer = null; flush().catch(() => {}); }, delay);
  },
  flush,
  get dirty() { return latest !== saved; },
  dispose() { active = false; cancelTimer(); },
 };
}
export function editableDraft(campaign) {
 return JSON.parse(JSON.stringify({ name: campaign.name ?? '', category: campaign.category ?? 'MARKETING',
  audience: campaign.audience ?? { type: 'crm', leadFilter: {} }, variants: campaign.variants ?? [],
  languageRule: campaign.languageRule ?? { mode: 'lead' }, senders: campaign.senders ?? {},
  schedule: campaign.schedule ?? {}, frequencyCap: campaign.frequencyCap ?? {},
  drip: campaign.drip ?? { steps: [] }, variantOptimisation: campaign.variantOptimisation ?? { enabled: false },
 }));
}
